const state = {
  loading: false,
  loading_text: '加载中',
  percentage: {
    start: 0,
    next: 100
  }
}

const getters = {
  loading: state => state.loading,
  loadingText: state => state.loading_text,
  percentage: state => state.percentage
}

const actions = {
  setLoading ({ commit }, data) {
    commit('changeLoading', data)
  },
  setLoadingText ({ commit }, data) {
    commit('changeLoadingText', data)
  },
  setPercentage ({ commit }, data) {
    commit('changePercentage', data)
  }
}

const mutations = {
  changeLoading (state, data) {
    state.loading = data
  },
  changeLoadingText (state, data) {
    state.loading_text = data
  },
  changePercentage (state, data) {
    state.percentage = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js